import { NgModule } from '@angular/core';
import { UserRoutingModule } from './user-routing.module';


@NgModule({
  declarations: [],
  imports: [
    UserRoutingModule
  ]
})
export class UserModule { }
